import { create } from "zustand";
import { OTPsSendResponse } from "@stytch/vanilla-js";

interface LoginAuthStore {
  // Form state
  email: string;
  password: string;

  // OTP flow state
  otpResponse: OTPsSendResponse | null;
  phoneNumber: string | null;
  verificationModalOpen: boolean;

  // Other modals
  forgotPasswordModalOpen: boolean;

  // Actions
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
  setOtpData: (response: OTPsSendResponse, phone: string) => void;
  setOtpResponse: (response: OTPsSendResponse | null) => void;
  setPhoneNumber: (phone: string | null) => void;
  setVerificationModalOpen: (open: boolean) => void;
  setForgotPasswordModalOpen: (open: boolean) => void;
  resetLoginState: () => void;
}

export const useLoginAuthStore = create<LoginAuthStore>((set) => ({
  // Initial state
  email: "",
  password: "",
  otpResponse: null,
  phoneNumber: null,
  verificationModalOpen: false,
  forgotPasswordModalOpen: false,

  // Actions
  setEmail: (email) => {
    set({ email });
  },

  setPassword: (password) => {
    set({ password });
  },
  setOtpData: (response, phone) => {
    set({
      otpResponse: response,
      phoneNumber: phone,
      verificationModalOpen: true,
    });
  },

  setOtpResponse: (response) => {
    set({ otpResponse: response });
  },

  setPhoneNumber: (phone) => {
    set({ phoneNumber: phone });
  },

  setVerificationModalOpen: (open) => {
    set({ verificationModalOpen: open });
  },

  setForgotPasswordModalOpen: (open) => {
    set({ forgotPasswordModalOpen: open });
  },

  resetLoginState: () => {
    set({
      email: "",
      password: "",
      otpResponse: null,
      phoneNumber: null,
      verificationModalOpen: false,
      forgotPasswordModalOpen: false,
    });
  },
}));
